<div class="grid-container margin-top">
    <report-command [dateRequired]="true" [fromDate]="fromDate" [toDate]="toDate" [runText]="runText" (reportGenerated)="generateReport($event)" (reportDownloaded)="downloadReport($event)"></report-command>
    <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data" [excelStyles]="excelStyles" aria-label="Onbase File Upload Report"></ag-grid-angular>
</div>
